export const STATIC_DEV_URL = 'http://localhost:3010/';
export const STATIC_TEST_URL = 'https://assets.animatron-test.com/static/';
export const STATIC_PROD_URL = 'https://assets.animatron.com/static/';
